/* eslint-disable react/prop-types */
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { useState } from 'react';
import LightboxModal from './LightboxModal';

export default function CartImage({ item }) {

  const [openLightbox, setOpenLightbox] = useState(false);

  return (
    <div>
      <Card
        raised
        sx={{
          maxWidth: '100%',
          margin: '0 auto',
          padding: '0.1em',
        }}
      >
        <CardMedia
          component="img"
          height="250"
          image={`/img/${item?.i}.png`}
          alt={'alt'}
          title={'titleasdasdsada'}
          sx={{ padding: '1em 1em 0 1em', objectFit: 'contain' }}
          onClick={() => setOpenLightbox(true)}
        />
      </Card>
      <LightboxModal
        images={[`/img/${item?.i}.png`]}
        mainSrc={`/img/${item?.i}.png`}
        photoIndex={0}
        setPhotoIndex={0}
        isOpen={openLightbox}
        onCloseRequest={() => setOpenLightbox(false)}
      />
    </div>
  );
}
